ui-cms-faq-category {
  display: block;

  .faq-overview__category-wrapper {
    margin-top: $sd-spacing-12;

    & > h3 {
      margin-bottom: $sd-spacing-8;
    }
  }

  .sd-leadtext {
    margin-top: $sd-spacing-4;
  }

  ui-cms-faq-teaser:nth-child(n + 2) {
    margin-top: $sd-spacing-12;
  }

  ui-cms-link-list {
    margin-top: $sd-spacing-8;
  }

  .sr-only {
    @include sr-only;
  }
}
